<template>
  <div class="blog-header">
    <div class="blog-header__container">
      <h1 class="blog-header__title">
        {{ _T(getPageTitle) }}
      </h1>
      <Navigation />
      <PopularTags
        v-if="!isRouteMatched('blog_post')"
        :tags="useBlogStore().tags"
      />
    </div>
  </div>
  <RouterView />
</template>

<script setup>
import Navigation from "~/nuxt_modules/blog/ui/components/Navigation.vue";
import PopularTags from "~/nuxt_modules/blog/ui/pages/Blog/PopularTags.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blogStore";
import { cleanUrlName } from "~/utils/strings.utils";

const route = useRoute();
const { fetchCategories, fetchTags, getCategory, getTag } = useBlogStore();

await Promise.all([fetchCategories(), fetchTags()]);

const category = computed(() => getCategory(route.params.categorySlug));
const tag = computed(() => getTag(route.params.tagSlug));

const pageSeoConfig = {
  blog_main: {
    name: () => "@Blog",
    metaTitle: () => {},
    metaDescription: () => {},
  },
  blog_tag: {
    name: () => `#${tag.value?.name}`,
    metaTitle: () => tag.value?.metaTitle,
    metaDescription: () => tag.value?.metaDescription,
  },
  blog_category: {
    name: () => category.value?.name,
    metaTitle: () => category.value?.metaTitle,
    metaDescription: () => category.value?.metaDescription,
  },
};

const getPageTitle = computed(() => {
  return pageSeoConfig[cleanUrlName(route.name)]?.name();
});

const getMetaTitle = computed(() => {
  return pageSeoConfig[cleanUrlName(route.name)]?.metaTitle();
});

const getMetaDescription = computed(() => {
  return pageSeoConfig[cleanUrlName(route.name)]?.metaDescription();
});

useSeoMeta({
  title: () => _T(getMetaTitle.value),
  description: () => _T(getMetaDescription.value),
});
</script>

<style scoped lang="scss">
.blog-header {
  padding: 16px;

  &__container {
    @extend %width-main;

    @include flex-container(column, flex-start);
    gap: 24px;

    margin-inline: auto;
  }

  &__title {
    @include font(34, 42, 600);

    @include mobile {
      @include font(22, 30, 600);
    }
  }
}
</style>
